import { useCallback, useEffect, useMemo } from 'react'

import { MessageSequenceStatus, WelcomeMessageScope } from '@api'
import { useUnit } from 'effector-react'

import {
  $welcomeMessageSortOptions,
  setWelcomeMessages,
} from '@/modules/creator-settings/welcome-messages/models.ts'
import {
  useDeleteWelcomeMessage,
  useToggleWelcomeMessageByMessagId,
  useWelcomeMessages,
} from '@/modules/creator-settings/welcome-messages/query/welcome-message-query'

export function useWelcomeMessageSettings() {
  const sortOption = useUnit($welcomeMessageSortOptions)

  const messages = useWelcomeMessages(WelcomeMessageScope.NEW_FANS, sortOption)
  const deleteMessage = useDeleteWelcomeMessage(
    WelcomeMessageScope.NEW_FANS,
    sortOption,
  )

  const toggleWelcomeMessageByMessagId = useToggleWelcomeMessageByMessagId(
    WelcomeMessageScope.NEW_FANS,
    sortOption,
  )

  const handleToggleChange = useCallback(
    async (id: number, value: boolean) => {
      return toggleWelcomeMessageByMessagId.mutateAsync({
        messageId: String(id),
        value: value
          ? MessageSequenceStatus.ACTIVE
          : MessageSequenceStatus.INACTIVE,
      })
    },
    [toggleWelcomeMessageByMessagId],
  )

  useEffect(() => {
    setWelcomeMessages(messages.data ?? [])
  }, [messages.data])

  return useMemo(
    () => ({
      messages: messages.data || [],
      deleteMessage: deleteMessage.mutateAsync,
      handleToggleChange,
    }),
    [messages.data, deleteMessage.mutateAsync, handleToggleChange],
  )
}
